import React, { Component } from "react";
import { connect } from "react-redux";
import {
    setMenuTopIndex,
    setMenuLeftContent,
    setMenuLeftIndex,
    setMenuLeftItemIndex
} from "../../../redux/actions/menuActions";
import Menu from "../Menu";
import Presence from "../../../modules/presence/presence/presence";
import AuthRender from "../../../containers/AuthRender";
import { SERVICES } from "../../../configs/constants";

class Home extends Component {
    componentDidMount() {
        this.props.setMenuTopIndex("presence");
        this.props.setMenuLeftContent(Menu);
        this.props.setMenuLeftIndex("presence");
        this.props.setMenuLeftItemIndex("");
    }
    render() {
        return (
            <AuthRender service={SERVICES.Presence} >
                <Presence/>
            </AuthRender>
        );
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setMenuTopIndex: index => {
            dispatch(setMenuTopIndex(index));
        },
        setMenuLeftContent: index => {
            dispatch(setMenuLeftContent(index));
        },
        setMenuLeftIndex: index => {
            dispatch(setMenuLeftIndex(index));
        },
        setMenuLeftItemIndex: index => {
            dispatch(setMenuLeftItemIndex(index));
        }
    };
};

export default connect(null, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// src/pages/presence/presence/Home.js